<template>
    <v-app>
        load_macs page
    </v-app>
</template>

<script>
    const fb = require('../firebase')

    export default {
        name: "LoadMACKeys",
        data() {
            return {
                startMac: [
                    {
                        "start": 33427000,
                        "end": 33427099,
                        "mac": "5D5EA89D371AD592"
                    },
                    {
                        "start": 33427100,
                        "end": 33427199,
                        "mac": "CB736EB6E92F9840"
                    },
                    {
                        "start": 33427200,
                        "end": 33427299,
                        "mac": "32A1318ADF9B7946"
                    },
                    {
                        "start": 33427300,
                        "end": 33427399,
                        "mac": "ADDFB35D0D102AD5"
                    },
                    {
                        "start": 33427400,
                        "end": 33427499,
                        "mac": "61344AD631082FE0"
                    },
                    {
                        "start": 33427500,
                        "end": 33427599,
                        "mac": "B0FE7925BC1931BA"
                    },
                    {
                        "start": 33427600,
                        "end": 33427699,
                        "mac": "1376D6B0A7455E0B"
                    },
                    {
                        "start": 33427700,
                        "end": 33427799,
                        "mac": "54026E51FE3B6D01"
                    },
                    {
                        "start": 33427800,
                        "end": 33427899,
                        "mac": "ADBFCDC2FEFDEA9D"
                    },
                    {
                        "start": 33427900,
                        "end": 33427999,
                        "mac": "C82364200757D604"
                    }
                ]
            }
        },
        mounted() {
            //this.addNewMacs()
            // this.changeRefunds()
            // this.updateUpdate()
        },
        methods: {
            updateUpdate: async function () {
                // 020254635
                // 020265641
                // 020284979
                let total_count = 0
                let mid_count = 0
                let mid = "020277344"
                await fb.settingsCollection
                // .where("merchant.merchantid", "==", mid)
                    .get()
                    .then((docs) => {
                        docs.forEach((doc) => {
                            total_count++
                            // console.log("check")
                            if (doc.data()["merchant.merchantid"] === mid) {
                                mid_count++
                                let newDoc = doc.data()
                                //delete newDoc["merchant"]
                                //newDoc["merchant"] = nil

                                newDoc["autoupdate.s3-endpoint"] = "kineticsmart.com"
                                newDoc["autoupdate.s3-bucket-name"] = "goodbox"
                                newDoc["autoupdate.s3-prefix"] = "autoupdate/191105-patch"
                                newDoc["autoupdate.latest_update"] = 1574886877
                                fb.settingsCollection.doc(doc.id).set(newDoc)
                            }
                        })
                        // console.log("total: " + total_count)
                        // console.log("mid: " + mid_count)
                    })
            },
            changeRefunds: async function () {
                let mid = "020284979"
                await fb.settingsCollection
                // .where("merchant.merchantid", "==", mid)
                    .get()
                    .then((docs) => {
                        docs.forEach((doc) => {
                            if (doc.data()["merchant.merchantid"] === mid) {
                                let newDoc = doc.data()
                                //delete newDoc["merchant"]
                                //newDoc["merchant"] = nil
                                newDoc["autoupdate.s3-prefix"] = "autoupdate/191028"
                                fb.settingsCollection.doc(doc.id).set(newDoc)
                            }
                        })
                        // console.log(count)
                    })
            },
            addNewMacs: function () {
                let order = 2000
                this.startMac.forEach(async function (newMac) {
                    await fb.macStartKeysCollection
                        .where('terminal_id', '==', String(newMac.start))
                        .get()
                        .then((doc) => {
                            if (doc.empty) {
                                for (let i = 0; i < 100; i++) {
                                    order = order + 1
                                    let newArray = {
                                        "acquirer": "aibms",
                                        "claimed": false,
                                        "logon": false,
                                        "merchant_master_key": newMac.mac,
                                        "order": order,
                                        "terminal_id": String((newMac.start + i)),
                                        "timestamp": new Date()
                                    }
                                    // console.log(newArray)
                                    fb.macStartKeysCollection
                                        .add(newArray)
                                        .then((d) => {
                                            console.log(d.id + " added")
                                        })
                                }
                            }
                        })
                })
            }
        }
    }
</script>

<style scoped>
</style>
